import { graphql } from "../gql";

export const OnboardingLiveSlotPlanFragment = graphql(`
  fragment OnboardingLiveSlotPlanItem on OnboardingLiveSlotPlan {
    slotId
    status
    teacherId
    forcedRoster
    reassignment {
      classRoomId
      fromTeacherId
      toTeacherId
    }
    issues {
      code
      severity
      relatedTeacherId
      relatedClassRoom {
        id
        type
        is1on1
        startUtc
        endUtc
        userGroupId
        teacherId
      }
    }
  }
`);

export const OnboardingLiveCreationIntentFragment = graphql(`
  fragment OnboardingLiveCreationIntentItem on OnboardingLiveCreationIntent {
    id
    userGroupId
    status
    createdByEmail
    createdAtUtc
    updatedAtUtc
    confirmedByEmail
    confirmedAtUtc
    cancelledByEmail
    cancelledAtUtc
    completedAtUtc
    lastCheckedAtUtc
    slots {
      id
      startUtc
      endUtc
      requestedTeacherId
      creationStatus
      onboardingLiveId
      creationFailureReason
      lastCheckPlan {
        ...OnboardingLiveSlotPlanItem
      }
      creationPlan {
        ...OnboardingLiveSlotPlanItem
      }
    }
  }
`);

export const OnboardingLiveFragment = graphql(`
  fragment OnboardingLiveItem on OnboardingLive {
    id
    startUtc
    endUtc
    userGroupId
    teacherId
    participantsCount
    capacity
    meetingUri
    pdfUrl
    creationIntentId
    hasStarted
    hasEnded
    feedback {
      participantsCount
      notes
      issues
      createdAtUtc
      updatedAtUtc
    }
    participants {
      id
      givenName
      familyName
      speakingLevel
    }
  }
`);
